export enum PMSType {
    None,
    NewHotel
}
